import React from 'react'
import { Box, Button, Dialog, DialogContent, Stack, Typography } from '@mui/material'

const MarkProjectCompleteModal = ({ open, projectName, loading, onClose, onConfirm }) => {
    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}
        >
            <DialogContent sx={{ p: 4 }}>
                <Stack alignItems="center" spacing={2}>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '999px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                            <path d="M2.08398 43.7493L25.0007 4.16602L47.9173 43.7493H2.08398ZM25.0007 37.4993C25.5909 37.4993 26.0861 37.2993 26.4861 36.8993C26.8861 36.4993 27.0854 36.0049 27.084 35.416C27.0826 34.8271 26.8826 34.3327 26.484 33.9327C26.0854 33.5327 25.5909 33.3327 25.0007 33.3327C24.4104 33.3327 23.9159 33.5327 23.5173 33.9327C23.1187 34.3327 22.9187 34.8271 22.9173 35.416C22.9159 36.0049 23.1159 36.5 23.5173 36.9014C23.9187 37.3028 24.4132 37.5021 25.0007 37.4993ZM22.9173 31.2493H27.084V20.8327H22.9173V31.2493Z" fill="#E2B93B" />
                        </svg>
                    </Box>

                    <Typography variant="h2" sx={{ fontWeight: 800, textAlign: 'center' }}>
                        Mark <span style={{ fontWeight: 900 }}>{projectName || 'project name'}</span> as complete?
                    </Typography>

                    <Typography variant="h4" sx={{ color: '#3A3A3A', textAlign: 'center', maxWidth: 520 }}>
                        Once marked complete, this project will be archived and no new tasks can be added. You can still view it in
                        your completed projects.
                    </Typography>

                    <Stack sx={{ width: '100%', pt: 2 }} spacing={1.25}>
                        <Button
                            variant="subtitle1"
                            disabled={loading}
                            onClick={onConfirm}
                            sx={{
                                height: 52,
                                borderRadius: 999,
                                bgcolor: '#F5C542',
                                color: 'rgba(0,0,0,0.85)',
                                fontWeight: 500,
                                '&:hover': { bgcolor: '#EAB308' },
                            }}
                        >
                            {loading ? 'Marking…' : 'Mark as complete'}
                        </Button>

                        <Button
                            variant="subtitle1"
                            disabled={loading}
                            onClick={onClose}
                            sx={{ height: 44, borderRadius: 999, color: 'rgba(0,0,0,0.65)', fontWeight: 500 }}
                        >
                            Cancel
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

export default MarkProjectCompleteModal
